import { ImageIcon } from 'lucide-react';
import { ScaledDesign } from '../marketing/ScaledDesign';
import { ProductImage } from '../../ui/ProductImage';
import type { MarketingDesign } from '../../core/types/marketing';
import type { SocialPost } from '../../core/types/social';
type Props = {
  post: SocialPost;
  design?: MarketingDesign;
  className?: string;
};

/** Het beeld van een post: het gekoppelde ontwerp, anders de eigen foto, anders een lege plek. */
export function PostVisual({
  post,
  design,
  className = ''
}: Props) {
  if (design) {
    return <div className={`overflow-hidden bg-sand ${className}`} data-id="element-4431" data-mp="3v3tdn6z4457s">
        <ScaledDesign design={design} fill data-id="element-4432" data-mp="3g5ra2ws2zjqj" />
      </div>;
  }
  if (post.image) return <ProductImage src={post.image} fit="cover" className={className} data-id="element-4433" data-mp="3l3sq18u7n2xs" />;
  return <div className={`flex items-center justify-center bg-sand text-muted ${className}`} data-id="element-4434" data-mp="3l5vpskl60afp">
      <ImageIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-4435" data-mp="1ebrzyeqp38ff" />
      <span className="sr-only" data-id="element-4436" data-mp="1jc5zf8e8da1u">Nog geen beeld</span>
    </div>;
}